import { createIcon } from "@chakra-ui/react";

export const KreozaYouTube = createIcon({
  displayName: "KreozaYouTube",
  viewBox: "0 0 48 48",
  path: (
    <>
      <path fill="#FF0000" d="M43.6 14.5s-.4-3.1-1.7-4.5c-1.6-1.7-3.3-1.7-4.1-1.8-5.7-.4-14.3-.4-14.3-.4s-8.6 0-14.3.4c-.8.1-2.5.1-4.1 1.8-1.3 1.4-1.7 4.5-1.7 4.5S2 17.7 2 20.9v6.2c0 3.2.4 6.4.4 6.4s.4 3.1 1.7 4.5c1.6 1.7 3.8 1.7 4.8 1.9 3.5.3 14.3.4 14.3.4s8.6 0 14.3-.4c.8-.1 2.5-.1 4.1-1.8 1.3-1.4 1.7-4.5 1.7-4.5s.4-3.2.4-6.4v-6.2c0-3.2-.4-6.4-.4-6.4z" />
      <path fill="#FFF" d="M19 31.3l12.5-7.3L19 16.7z" />
    </>
  ),
});
